<template>
  <div class="position">
    <div class="widget" v-for="widget in widgets" :key="widget.id" :title="widget.title">
      <div v-if="!widget.hideTitle">
        <h1 class="module-title">{{widget.title}}</h1>
      </div>
      <template v-if="widget.type == 'menu'">
        <WidgetMenu :menus="widget.menuItems" :hideMenuImage="widget.hideMenuImage"/>
      </template>
      <div class="widget-body" v-else-if="widget.type == 'html'" v-html="widget.content"></div>
      <template v-else-if="widget.type == 'slider'">
        <WidgetSlider :sliders="widget.sliders" :speed="widget.sliderSpeed"/>
      </template>
      <template v-else-if="widget.type == 'blog'">
        <WidgetBlog :pages="widget.pages" :blog="widget.blog"/>
      </template>
      <template v-else>
        Не задан тип виджета
      </template>
    </div>
  </div>
</template>

<script>
  import WidgetMenu from '@/components/widget/WidgetMenu'
  import WidgetSlider from '@/components/widget/WidgetSlider'
  import WidgetBlog from '@/components/widget/WidgetBlog'
  import CMS from '@/model/cms'

  export default {
    components: {
      WidgetMenu,
      WidgetSlider,
      WidgetBlog
    },
    props: {
      position: String,
      useTab: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      widgets: []
    }),
    mounted () {
      CMS.loadWidgetByPosition(this.position)
        .then(response => {
          this.widgets = response.data
        })
        .catch(error => {
          //@todo ошибки
        })

    }
  }
</script>
